import { GameCatalog, GameRegistry } from '@everyturn/engine/runtime';
import type { AvailableGameCatalogEntry } from './catalog-entry.js';
import { bridgeCatalogEntry } from './games/bridge/catalog-entry.js';
import { ginRummyCatalogEntry } from './games/gin-rummy/catalog-entry.js';
import { heartsCatalogEntry } from './games/hearts/catalog-entry.js';
import { layoutPreviewCatalogEntry } from './games/layout-preview/catalog-entry.js';
import { layoutTestCatalogEntry } from './games/layout-test/catalog-entry.js';
import { shuffleDemoCatalogEntry } from './games/shuffle-demo/catalog-entry.js';
import { sortSpreadTestCatalogEntry } from './games/sort-spread-test/catalog-entry.js';
import { sortableTestCatalogEntry } from './games/sortable-test/catalog-entry.js';
import { spadesCatalogEntry } from './games/spades/catalog-entry.js';
import { stripTestCatalogEntry } from './games/strip-test/catalog-entry.js';

export type { AvailableGameCatalogEntry } from './catalog-entry.js';

const entries = [
  bridgeCatalogEntry,
  heartsCatalogEntry,
  spadesCatalogEntry,
  ginRummyCatalogEntry,
  layoutTestCatalogEntry,
  layoutPreviewCatalogEntry,
  shuffleDemoCatalogEntry,
  stripTestCatalogEntry,
  sortableTestCatalogEntry,
  sortSpreadTestCatalogEntry,
] satisfies readonly AvailableGameCatalogEntry[];

export function createGameCatalog(scope: 'production' | 'development' = 'production'): GameCatalog {
  return new GameCatalog(entries.filter((entry) => scope === 'development' || entry.availability === 'production'));
}

/** Server composition preloads its enabled set; action handling stays synchronous. */
export async function createGameRegistry(scope: 'production' | 'development' = 'production'): Promise<GameRegistry> {
  const catalog = createGameCatalog(scope);
  const definitions = await Promise.all(catalog.list().map((descriptor) => catalog.load(descriptor.gameId)));
  const registry = new GameRegistry();
  for (const definition of definitions) registry.register(definition);
  return registry;
}
